exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.apexcharts-menu-item.exportSVG {\n  display: none;\n}\n.apexcharts-menu-item.exportPNG {\n  display: none;\n}\n", ""]);

// exports
